<div class="container">
  <div class="top">
    <nz-table #nzTable class="v4-layout-list" [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
      <thead>
        <tr>
          <th>{{ "word.type" | translate }}</th>
          <th>{{ "word.item" | translate }}</th>
          <th>{{ "word.amount" | translate }}</th>
          <th>{{ "word.payment_method" | translate }}</th>
          <th>{{ "order.trade_time" | translate }}</th>
          <th>{{ "word.remarks" | translate }}</th>
          <th>{{ "word.operator" | translate }}</th>
          <th [nzWidth]="'100px'">{{ "word.operate" | translate }}</th>
        </tr>
      </thead>
      <tbody class="v4-layout-list-body">
        <tr *ngFor="let data of nzTable.data">
          <td>{{ getTypeName(data?.type) }}</td>
          <td>
            <div *ngIf="data?.type === 1">
              {{ getInOptionName(data?.action_type) }}
            </div>
            <div *ngIf="data?.type === -1">
              {{ getOutOptionName(data?.action_type) }}
            </div>
          </td>
          <td>{{ data?.currency }}&nbsp;{{ data?.amount }}</td>
          <td>
            <div class="credentials">
              <span class="type" *ngIf="data?.type === 1">{{ getInTradeName(data?.payment_method) }}</span>
              <span class="type" *ngIf="data?.type === -1">{{ getOutTradeName(data?.payment_method) }}</span>
              <div class="pics" (click)="viewVoucher(data?.invoice)" *ngIf="data?.invoice?.length > 0">
                <img src="/assets/icon/attachment.png" />
                <span class="number">{{ data?.invoice?.length }}</span>
              </div>
            </div>
          </td>
          <td>{{ data?.action_time | dateformat }}</td>
          <td nzBreakWord>{{ data?.note ? data?.note : "-" }}</td>
          <td>{{ data?.operator_name }}</td>
          <td>
            <div class="operation">
              <div class="delete" (click)="delete(data)">
                {{ "word.delete" | translate }}
              </div>
              <div class="edit" (click)="edit(data?.transaction_id)">
                {{ "word.modify" | translate }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
